module.exports = __webpack_public_path__ + "img/blue-logo.08ca675a.png";